import { Component } from '@angular/core';

@Component({
  selector: 'adminapp-summary-ews-health-check-report',
  templateUrl: './summary-ews-health-check-report.component.html',
  styleUrls: ['./summary-ews-health-check-report.component.scss']
})
export class SummaryEwsHealthCheckReportComponent {

  constructor() { }
}
